import { IconButton, Tooltip } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

// Row shape used by the Reference "Partners" tab EditableDataGrid (see PartnerLinkRow in
// ReferenceForm.tsx / LinkedPartnerType in dataTypes.ts). Only the field this cell needs.
type ReferencePartnerActionsCellRow = {
  id: number; // partnerID
};

type ReferencePartnerActionsCellProps = {
  row: ReferencePartnerActionsCellRow;
};

// Mirrors ReferenceExpertActionsCell.tsx's link-out pattern, but for a single partner row
// on a reference's Partners tab: link straight to that partner's own detail page
// (/partners/:partnerID). There's no CV-equivalent action here, so this is a single icon.
function ReferencePartnerActionsCell({ row }: ReferencePartnerActionsCellProps) {
  const navigate = useNavigate();

  return (
    <Tooltip title="View Partner Details">
      <IconButton size="small" onClick={() => navigate(`/partners/${row.id}`)}>
        <ArrowForward fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}

export default ReferencePartnerActionsCell;
